module.exports = __webpack_public_path__ + "img/ic_plane.ef40c42d.svg";